import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";

import * as accountsReducer from "containers/Accounts/reducer";
import * as loginReducer from "containers/Login/reducer";

import moment from "moment";

const LLM_MODELS_PLACEHOLDER = [
  {
    name: "Analytics Fine Tuned Model",
    id: "1",
    price: 0,
    created_date: "2024-03-06T19:45:16",
    created_by: { fullname: "Aible Test", id: "18" },
    metadata: {
      base_model: "mistral",
      use_case: "Data Analytics",
      summary: "A description of what kind of insights the users can expect to see.",
      details: "",
      downloads: 100,
      like_count: 5,
      dislike_count: 0
    },
    type: "FINE_TUNED_MODEL",
    source: {
      account_id: 2550,
      comment_count: 0,
      created_by: {
        fullname: "Aible Test",
        id: 18
      },
      created_date: "2024-03-05T00:19:53",
      deleted: "NOT_DELETED",
      description: "",
      dislike_count: 0,
      feedback: "NONE",
      folder_id: 357,
      id: 1330,
      like_count: 0,
      metadata: {
        base_model_id: "mistral",
        fine_tuning_data_id: 599,
        process_metadata: {
          job_id: "4272128515345743872",
          state: "PIPELINE_STATE_SUCCEEDED",
          type: "VERTEX_PIPELINE_JOB"
        },
        status: "COMPLETE",
        tuning_output: {
          endpoint_id: "7005131517072506880",
          model_id: "7836824102554828800@1",
          type: "VERTEX_MODEL"
        }
      },
      name: "test failure",
      permissions: {
        can_delete: true,
        can_edit: true,
        can_give_feedback: true,
        can_manage_permissions: true,
        can_view: true
      },
      tenant_id: 2,
      type: "FINE_TUNED_MODEL",
      updated_date: "2024-03-05T22:35:03"
    }
  },
  {
    name: "NLQ Model",
    id: "2",
    price: 0,
    created_date: "2024-03-06T19:45:16",
    created_by: { fullname: "Aible Test", id: "18" },
    metadata: {
      base_model: "mistral",
      use_case: "Document Summarization",
      summary: "A description of what kind of insights the users can expect to see.",
      details: "",
      downloads: 100,
      like_count: 5,
      dislike_count: 0
    },
    type: "FINE_TUNED_MODEL",
    source: {
      account_id: 2550,
      comment_count: 0,
      created_by: {
        fullname: "Aible Test",
        id: 18
      },
      created_date: "2024-03-05T00:19:53",
      deleted: "NOT_DELETED",
      description: "",
      dislike_count: 0,
      feedback: "NONE",
      folder_id: 357,
      id: 1330,
      like_count: 0,
      metadata: {
        base_model_id: "mistral",
        fine_tuning_data_id: 599,
        process_metadata: {
          job_id: "4272128515345743872",
          state: "PIPELINE_STATE_SUCCEEDED",
          type: "VERTEX_PIPELINE_JOB"
        },
        status: "COMPLETE",
        tuning_output: {
          endpoint_id: "7005131517072506880",
          model_id: "7836824102554828800@1",
          type: "VERTEX_MODEL"
        }
      },
      name: "test failure",
      permissions: {
        can_delete: true,
        can_edit: true,
        can_give_feedback: true,
        can_manage_permissions: true,
        can_view: true
      },
      tenant_id: 2,
      type: "FINE_TUNED_MODEL",
      updated_date: "2024-03-05T22:35:03"
    }
  },
  {
    name: "Document Summarization Model",
    id: "3",
    price: 5,
    created_date: "2024-03-06T19:45:16",
    created_by: { fullname: "Aible Test", id: "18" },
    metadata: {
      base_model: "text-bison@002",
      use_case: "10K Comparison",
      summary: "A description of what kind of insights the users can expect to see.",
      details: "",
      downloads: 100,
      like_count: 5,
      dislike_count: 0
    },
    type: "FINE_TUNED_MODEL",
    source: {
      account_id: 2550,
      comment_count: 0,
      created_by: {
        fullname: "Aible Test",
        id: 18
      },
      created_date: "2024-03-05T00:19:53",
      deleted: "NOT_DELETED",
      description: "",
      dislike_count: 0,
      feedback: "NONE",
      folder_id: 357,
      id: 1330,
      like_count: 0,
      metadata: {
        base_model_id: "text-bison@002",
        fine_tuning_data_id: 599,
        process_metadata: {
          job_id: "4272128515345743872",
          state: "PIPELINE_STATE_SUCCEEDED",
          type: "VERTEX_PIPELINE_JOB"
        },
        status: "COMPLETE",
        tuning_output: {
          endpoint_id: "7005131517072506880",
          model_id: "7836824102554828800@1",
          type: "VERTEX_MODEL"
        }
      },
      name: "test failure",
      permissions: {
        can_delete: true,
        can_edit: true,
        can_give_feedback: true,
        can_manage_permissions: true,
        can_view: true
      },
      tenant_id: 2,
      type: "FINE_TUNED_MODEL",
      updated_date: "2024-03-05T22:35:03"
    }
  }
];

const CHAT_APPS_PLACEHOLDER = [];

const USE_CASES_PLACEHOLDER = [];

export function getModels() {
  const modelString = localStorage.getItem("market_model_listings");
  let retModels = LLM_MODELS_PLACEHOLDER;

  if (modelString !== null || modelString?.length > 0) {
    const parsedModels = JSON.parse(modelString);
    retModels = [...parsedModels, ...LLM_MODELS_PLACEHOLDER];
  }

  return new Promise(function (resolve, reject) {
    setTimeout(() => resolve(retModels), 2000);
  });
}

export function getChatApps() {
  return new Promise(function (resolve, reject) {
    setTimeout(() => resolve(CHAT_APPS_PLACEHOLDER), 3000);
  });
}

export function getUseCases() {
  return new Promise(function (resolve, reject) {
    setTimeout(() => resolve(USE_CASES_PLACEHOLDER), 2000);
  });
}

export function publishModel(modelItem) {
  const modelString = localStorage.getItem("market_model_listings");
  let retModels = [modelItem];
  if (modelString !== null || modelString?.length > 0) {
    const parsedModels = JSON.parse(modelString);
    retModels = [modelItem, ...parsedModels];
  }

  localStorage.setItem("market_model_listings", JSON.stringify(retModels));

  return new Promise(function (resolve, reject) {
    setTimeout(() => resolve([...retModels, ...LLM_MODELS_PLACEHOLDER]), 1000);
  });
}

export function addItemToFolder(item, folderId) {
  return (dispatch, getState) => {
    const purchaseString = localStorage.getItem("market_purchases");
    const currentDate = moment().format();

    const selectedAccountId = accountsReducer.getSelectedAccountId(getState());
    const selectedTenant = loginReducer.getSelectedTenant(getState());

    let retPurchase = item?.source;
    retPurchase.folder_id = folderId;
    retPurchase.created_by = item?.created_by;
    retPurchase.created_date = currentDate;
    retPurchase.updated_date = currentDate;
    retPurchase.id = item?.id;
    retPurchase.name = item?.name;
    retPurchase.tenant_id = selectedTenant?.id;

    if (item?.type === "FINE_TUNED_MODEL") {
      retPurchase.description = item?.metadata?.summary;
      retPurchase.like_count = 0;
      retPurchase.dislike_count = 0;
      retPurchase.comment_count = 0;
      retPurchase.account_id = selectedAccountId;
    }

    let updatedPurchases = [retPurchase];

    if (purchaseString !== null || purchaseString?.length > 0) {
      const parsedPurchases = JSON.parse(purchaseString);
      updatedPurchases = [retPurchase, ...parsedPurchases];
    }

    localStorage.setItem("market_purchases", JSON.stringify(updatedPurchases));

    return new Promise(function (resolve, reject) {
      setTimeout(() => resolve(retPurchase), 3000);
    });
  };
}
